import * as types from './ContentsTypes';

export default function ContentsReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_CONTENTS:
            return {
                ...state,
                getContents: {
                    ...state.getContents,
                    contents: payload.data,
                    firstContent: payload.first,
                    lastContent: payload.last,
                    nextContents: payload.next,
                    contentsFilter: [],
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CONTENTS_LOADING:
            return {
                ...state,
                getContents: {
                    ...state.getContents,
                    loading: true
                },
            };
        case types.GET_CONTENTS_ERROR:
            return {
                ...state,
                getContents: {
                    ...state.getContents,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CONTENTS_ALL_MONTH:
            return {
                ...state,
                getContentsAllMonth: {
                    ...state.getContentsAllMonth,
                    contents: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CONTENTS_ALL_MONTH_LOADING:
            return {
                ...state,
                getContentsAllMonth: {
                    ...state.getContentsAllMonth,
                    loading: true
                },
            };
        case types.GET_CONTENTS_ALL_MONTH_ERROR:
            return {
                ...state,
                getContentsAllMonth: {
                    ...state.getContentsAllMonth,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CONTENTS_BY_ID:
            return {
                ...state,
                getContentsById: {
                    ...state.getContentsById,
                    content: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_CONTENTS_BY_ID_LOADING:
            return {
                ...state,
                getContentsById: {
                    ...state.getContentsById,
                    loading: true,
                },
            };
        case types.GET_CONTENTS_BY_ID_ERROR:
            return {
                ...state,
                getContentsById: {
                    ...state.getContentsById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_CONTENTS_FILTER:
            return {
                ...state,
                getContents: {
                    ...state.getContents,
                    contentsFilter: payload.data,
                    firstContent: payload.first,
                    lastContent: payload.last,
                    nextContents: payload.next,
                    loading: false
                },
            };
        case types.GET_CONTENTS_FILTER_LOADING:
            return {
                ...state,
                getContents: {
                    ...state.getContents,
                    loading: true
                },
            };
        case types.GET_CONTENTS_FILTER_ERROR:
            return {
                ...state,
                getContents: {
                    ...state.getContents,
                    contentsFilter: [],
                    loading: false
                },
            };
        case types.GET_CONTENTS_EXCEL:
            return {
                ...state,
                getContentsExcel: {
                    ...state.getContentsExcel,
                    contents: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_CONTENTS_EXCEL_LOADING:
            return {
                ...state,
                getContentsExcel: {
                    ...state.getContentsExcel,
                    loading: true
                },
            };
        case types.GET_CONTENTS_EXCEL_ERROR:
            return {
                ...state,
                getContentsExcel: {
                    ...state.getContentsExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CONTENTS_FILTER_EXCEL:
            return {
                ...state,
                getContentsExcel: {
                    ...state.getContentsExcel,
                    contentsFilter: payload.data,
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_CONTENTS_FILTER_EXCEL_LOADING:
            return {
                ...state,
                getContentsExcel: {
                    ...state.getContentsExcel,
                    loading: true
                },
            };
        case types.GET_CONTENTS_FILTER_EXCEL_ERROR:
            return {
                ...state,
                getContentsExcel: {
                    ...state.getContentsExcel,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CONTENTS_EXCEL_RESET_STATE:
            return {
                ...state,
                getContentsExcel: {
                    ...state.getContentsExcel,
                    contents: [],
                    contentsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_CONTENTS_BY_ID:
            return {
                ...state,
                updateContentsById: {
                    ...state.updateContentsById,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getContentsById: {
                    ...state.getContentsById,
                    content: {
                        ...state.getContentsById.content,
                        isApproved: payload.newIsApproved,
                        status: payload.newStatus,
                        usuarioAtendio: payload.newUserAttends,
                        comentario: payload.newCommentary
                    },
                },
            };
        case types.UPDATE_CONTENTS_BY_ID_LOADING:
            return {
                ...state,
                updateContentsById: {
                    ...state.updateContentsById,
                    loading: true
                },
            };
        case types.UPDATE_CONTENTS_BY_ID_ERROR:
            return {
                ...state,
                updateContentsById: {
                    ...state.updateContentsById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.VERIFY_CONTENT_BY_ID:
            return {
                ...state,
                verifyContent: {
                    ...state.verifyContent,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.VERIFY_CONTENT_BY_ID_LOADING:
            return {
                ...state,
                verifyContent: {
                    ...state.verifyContent,
                    loading: true
                },
            };
        case types.VERIFY_CONTENT_BY_ID_ERROR:
            return {
                ...state,
                verifyContent: {
                    ...state.verifyContent,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.VERIFY_CONTENT_BY_ID_RESET_STATE:
            return {
                ...state,
                verifyContent: {
                    ...state.verifyContent,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CONTENTS_RESET_STATE:
            return {
                getContents: {
                    contents: [],
                    firstContent: null,
                    lastContent: null,
                    nextContents: null,
                    contentsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getContentsAllMonth: {
                    contents: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getContentsById: {
                    content: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                updateContentsById: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                verifyContent: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getContentsExcel: {
                    contents: [],
                    contentsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                }
            };
    
        default:
            return state;
    }
}